import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import PropTypes from 'prop-types';
import './forminputs.css';
class RenderDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { is_focus: false };
    this.datePickerRef = null;
  }

  isValidDate = (str) => {
    let d = moment(str);
    if (d == null || !d.isValid()) return false;
    else return true;
  };

  componentDidMount = () => {
    if (this.datePickerRef) {
      this.datePickerRef.input.setAttribute('readonly', true);
    }
  };

  inputFocus = () => {
    this.setState({ is_focus: true });
  };

  inputBlur = () => {
    this.setState({ is_focus: false });
  };

  handleChangeRaw = () => {
    //to make date picker no typeable
    let s = document.getElementById(this.id);
    s.value = moment(this.props.input.value).format('DD/MM/YYYY');
  };

  render() {
    const {
      input,
      placeholder,
      maxDate,
      minDate,
      meta: { touched, error },
      isTimePicker,
      onlyWeekDays,
      excludeDates,
      showDisabledWithIcon,
      newUiLabel = false,
      labelText = ''
    } = this.props;
    let disabled = this.props.disabled || false;
    this.id = this.props.id ? this.props.id.replace('_', '-') : input.name.replace('_', '-');
    return (
      <div
        className={`render-date-picker ${disabled ? 'disabled' : ''}`}
        style={disabled ? { opacity: '.4' } : null}
      >
        {newUiLabel && labelText && (
          <div
            className={`${
              error && touched ? 'date-picker-label-new-error' : 'date-picker-label-new'
            }`}
          >
            {labelText}
          </div>
        )}

        <div className="input-error-wrapper">
          {!newUiLabel && (
            <div className={'date-picker-label'}>{input.value ? placeholder : ''}</div>
          )}
          <DatePicker
            {...input}
            ref={(ref) => (this.datePickerRef = ref)}
            className={`input form-flow${disabled ? ' disabled' : ''}`}
            placeholderText={placeholder}
            onFocus={this.inputFocus}
            onBlur={this.inputBlur}
            showTimeSelect={isTimePicker || false}
            timeIntervals={isTimePicker ? 15 : 0}
            dateFormat={isTimePicker ? 'LLL' : 'DD/MM/YYYY'}
            maxDate={maxDate || null}
            minDate={minDate || null}
            id={this.id}
            showYearDropdown
            showMonthDropdown
            disabledKeyboardNavigation
            disabled={disabled || showDisabledWithIcon}
            onChangeRaw={this.handleChangeRaw}
            dropdownMode="select" //userfriendly UX for year and month dropdown
            filterDate={(moment) => {
              if (!onlyWeekDays) return true;
              let dayNo = moment.weekday();
              return dayNo !== 0 && dayNo !== 6;
            }}
            excludeDates={excludeDates || []}
          />
          {touched && error && <span className="error-msg">{error}</span>}
        </div>
      </div>
    );
  }
}

RenderDatePicker.propTypes = {
  id: PropTypes.string,
  input: PropTypes.any,
  placeholder: PropTypes.string,
  meta: PropTypes.any,
  className: PropTypes.string,
  isTimePicker: PropTypes.bool,
  maxDate: PropTypes.any,
  minDate: PropTypes.any,
  onlyWeekDays: PropTypes.bool,

  disabled: PropTypes.bool,
  excludeDates: PropTypes.array,
  showDisabledWithIcon: PropTypes.any,
  newUiLabel: PropTypes.bool,
  labelText: PropTypes.bool
};

export default RenderDatePicker;
